import request from '@/utils/request'

// 已报检未入库报表列表
export function apiInvWipCompletedNotStoredList(query) {
  return request({
    url: '/inv/invWipCompletedNotStored/selectReportList',
    method: 'get',
    params: query
  })
}

// 已报检未入库报表导出
export function apiInvWipCompletedNotStoredExportReport (data) {
  return request({
    url: `/inv/invWipCompletedNotStored/exportReport`,
    method: 'post',
    data: data
  })
}

// mo票领料退料列表
export function apiMesQueryRequisitionList (data) {
  return request({
    url: `/mes/mesDiscreteJobsCcMo/queryRequisitionList`,
    method: 'post',
    data: data
  })
}

// 查询标签列表退料详情
export async function apiGetReturnLabelDetailList (data) {
  return request({
    url: '/mes/mesRequisitionCcDetail/returnLabelDetailList',
    method: 'get',
    params: data
  })
}

// mo票领料退料报表导出
export function apiMesRequisitionExport (data) {
  return request({
    url: '/mes/mesDiscreteJobsCcMo/requisitionExport',
    method: 'post',
    data: data
  })
}

// 计划订单池订单报表列表
export function apiSopPurchasePlanPoolReportList (data) {
  return request({
    url: '/scp/sopPurchasePlanPoolReport/list',
    method: 'post',
    data: data
  })
}

// 计划订单池订单报表导出
export function apiSopPurchasePlanPoolReportExport (data) {
  return request({
    url: '/scp/sopPurchasePlanPoolReport/export',
    method: 'post',
    data: data
  })
}

// 计划订单池订单报表列表 汇总
export function apiGetQueryTotal (data) {
  return request({
    url: '/scp/sopPurchasePlanPoolReport/queryTotal',
    method: 'post',
    data: data
  })
}

// 生产操作列表
export async function apiInvProductionOperationReportList (data) {
  return request({
    url: '/inv/invProductionOperationReport/list',
    method: 'get',
    params: data
  })
}

// 生产操作导出
export function apiInvProductionOperationReportExport (data) {
  return request({
    url: '/inv/invProductionOperationReport/export',
    method: 'post',
    data: data
  })
}
